import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PreviewListComponent } from './preview-list.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [PreviewListComponent],
    exports: [PreviewListComponent],
})
export class FeaturePreviewListModule {}
